module.exports = __webpack_public_path__ + "static/img/qrCode3.6b6018a2.png";